var installedChunks = {889: 0,};
var uniqueName = "spirii_router";
function handleCssComposes(exports, composes) {
	for (var i = 0; i < composes.length; i += 3) {
		var moduleId = composes[i];
		var composeFrom = composes[i + 1];
		var composeVar = composes[i + 2];
		var composedId = __webpack_require__(composeFrom)[composeVar];
		exports[moduleId] = exports[moduleId] + " " + composedId
	}
}
var loadCssChunkData = (target, chunkId) => {

installedChunks[chunkId] = 0;

} 
var loadingAttribute = "data-rspack-loading";
var loadStylesheet = (chunkId, url, done, hmr, fetchPriority) => {
	var link,
		needAttach,
		key = "chunk-" + chunkId;
	if (!hmr) {
		var links = document.getElementsByTagName("link");
		for (var i = 0; i < links.length; i++) {
			var l = links[i];
			var href = l.getAttribute("href") || l.href;
			if (href && !href.startsWith(__webpack_require__.p)) {
				href =
					__webpack_require__.p + (href.startsWith("/") ? href.slice(1) : href);
			}
			if (
				l.rel == "stylesheet" &&
				((href && href.startsWith(url)) ||
					l.getAttribute("data-rspack") == uniqueName + ":" + key)
			) {
				link = l;
				break;
			}
		}
		if (!done) return link;
	}
	if (!link) {
		needAttach = true;
		link = document.createElement("link");
if (__webpack_require__.nc) {
  link.setAttribute("nonce", __webpack_require__.nc);
}

link.setAttribute("data-rspack", uniqueName + ":" + key);


link.setAttribute(loadingAttribute, 1);
link.rel = "stylesheet";
link.href = url;


	}
	var onLinkComplete = (prev, event) => {
		link.onerror = link.onload = null;
		link.removeAttribute(loadingAttribute);
		clearTimeout(timeout);
		if (event && event.type != "load" && link.parentNode) link.parentNode.removeChild(link);
		done(event);
		if (prev) return prev(event);
	};
	if (link.getAttribute(loadingAttribute)) {
		var timeout = setTimeout(
			onLinkComplete.bind(null, undefined, { type: "timeout", target: link }),
			120000 
		);
		link.onerror = onLinkComplete.bind(null, link.onerror);
		link.onload = onLinkComplete.bind(null, link.onload);
	} else onLinkComplete(undefined, { type: "load", target: link });
	if (hmr && hmr.getAttribute("fetchpriority")) link.setAttribute("fetchpriority", hmr.getAttribute("fetchpriority"));
	hmr ? document.head.insertBefore(link, hmr) : needAttach && document.head.appendChild(link);
	return link;
};
loadCssChunkData(__webpack_require__.m, 0, 889);
__webpack_require__.f.css = (chunkId, promises, fetchPriority) => {
	// css chunk loading
	var installedChunkData = __webpack_require__.o(installedChunks, chunkId)
		? installedChunks[chunkId]
		: undefined;
	if (installedChunkData !== 0) {
		// 0 means "already installed".

		// a Promise means "currently loading".
		if (installedChunkData) {
			promises.push(installedChunkData[2]);
		} else {
			if (889 == chunkId) {
				// setup Promise in chunk cache
				var promise = new Promise(function (resolve, reject) {
					installedChunkData = installedChunks[chunkId] = [resolve, reject];
				});
				promises.push((installedChunkData[2] = promise));

				// start chunk loading
				var url = __webpack_require__.p + __webpack_require__.k(chunkId);
				// create error before stack unwound to get useful stacktrace later
				var error = new Error();
				var loadingEnded = function (event) {
					if (__webpack_require__.o(installedChunks, chunkId)) {
						installedChunkData = installedChunks[chunkId];
						if (installedChunkData !== 0) installedChunks[chunkId] = undefined;
						if (installedChunkData) {
							if (event.type !== "load") {
								var errorType = event && event.type;
								var realSrc = event && event.target && event.target.src;
								error.message =
									"Loading css chunk " +
									chunkId +
									" failed.\n(" +
									errorType +
									": " +
									realSrc +
									")";
								error.name = "ChunkLoadError";
								error.type = errorType;
								error.request = realSrc;
								installedChunkData[1](error);
							} else {
								loadCssChunkData(__webpack_require__.m, chunkId);
								installedChunkData[0]();
							}
						}
					}
				};
				if (typeof document !== 'undefined') {
					loadStylesheet(chunkId, url, loadingEnded, undefined, fetchPriority);
				} else { loadingEnded({ type: 'load' }); }
			} else installedChunks[chunkId] = 0;
		}
	}
};
